import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { BuildTriggerCreateRequest, BuildTriggerPatch } from '@hangar/shared';
import { createBuildTrigger, deleteBuildTrigger, listBuildTriggers, retryTriggerWebhook, updateBuildTrigger } from './endpointsTriggers';

const key = (appId: string) => ['build-triggers', appId] as const;

/** The app's build triggers and its repository webhook; refreshed every 15 s while open (pushes land in the background). */
export const useBuildTriggers = (appId: string) => useQuery({ queryKey: key(appId), queryFn: () => listBuildTriggers(appId), refetchInterval: 15_000 });

/** Create, edit, delete and Retry; every write refreshes the list (the webhook state may have changed too). */
export function useBuildTriggerMutations(appId: string) {
  const qc = useQueryClient();
  const refresh = () => void qc.invalidateQueries({ queryKey: key(appId) });
  return {
    create: useMutation({ mutationFn: (body: BuildTriggerCreateRequest) => createBuildTrigger(appId, body), onSettled: refresh }),
    update: useMutation({ mutationFn: (v: { id: string; body: BuildTriggerPatch }) => updateBuildTrigger(v.id, v.body), onSettled: refresh }),
    remove: useMutation({ mutationFn: (id: string) => deleteBuildTrigger(id), onSettled: refresh }),
    retry: useMutation({ mutationFn: () => retryTriggerWebhook(appId), onSettled: refresh }),
  };
}
